import axios from "axios";
import { getToken, removeToken } from "@/utils/mangeCookie";
import router from "@/router/router";
import { ElMessage, ElMessageBox } from "element-plus";
import { v4 as uuidv4 } from "uuid";

const http = axios.create({
  // baseURL: '/api',
  timeout: 10000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
    "Content-Type": "application/json",
  },
});

let loginPromptPromise = null;

function createAuthRequiredError() {
  const error = new Error("登录状态已失效");
  error.code = "AUTH_REQUIRED";
  return error;
}

function getCurrentRedirect() {
  const currentRoute = router.currentRoute.value;
  if (!currentRoute || currentRoute.path === "/login" || currentRoute.path === "/logon") {
    return "/home";
  }
  return currentRoute.fullPath || "/home";
}

function showLoginPrompt() {
  if (router.currentRoute.value.path === "/login" || router.currentRoute.value.path === "/logon") {
    return Promise.resolve();
  }

  if (loginPromptPromise) {
    return loginPromptPromise;
  }

  const redirect = getCurrentRedirect();
  removeToken();
  loginPromptPromise = ElMessageBox.confirm(
    "登录状态已过期，您可以继续留在该页面，或者重新登录",
    "系统提示",
    {
      confirmButtonText: "重新登录",
      cancelButtonText: "取消",
      type: "warning",
    },
  )
    .then(() => router.replace({ path: "/login", query: { redirect } }))
    .catch(() => undefined)
    .finally(() => {
      loginPromptPromise = null;
    });

  return loginPromptPromise;
}

// 添加请求拦截器
http.interceptors.request.use(
  (config) => {
    // 当以 FormData 上传文件时，如未显式指定 Content-Type 或仍为默认 application/json，则移除之，交由浏览器设置边界
    if (config && config.data && typeof FormData !== "undefined" && config.data instanceof FormData) {
      const ct = config.headers && config.headers["Content-Type"];
      if (!ct || ct === "application/json") {
        if (config.headers && config.headers["Content-Type"]) delete config.headers["Content-Type"];
      }
    }
    config.headers.traceId = uuidv4();
    if (config.whiteUrl) {
      return config;
    }

    const token = getToken();
    if (!token) {
      return Promise.reject(createAuthRequiredError());
    }

    config.headers["Token"] = token;
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
http.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status !== 200) {
      if (response.status === 401) {
        showLoginPrompt();
      } else {
        ElMessage({
          message: res.message || "Error",
          type: "error",
          duration: 5 * 1000,
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  function (error) {
    if (error?.response?.status === 401) {
      showLoginPrompt();
    }
    return Promise.reject(error);
  },
);

export default http;
